var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-headline margin-top-0",class:{ 'margin-bottom-35': !_vm.isMobile }},[_vm._t("default",function(){return [(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e()]}),_vm._v(" "),(_vm.link)?_c('NuxtLink',{staticClass:"headline-link",attrs:{"to":_vm.link.to}},[_vm._v(_vm._s(_vm.link.name))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }